import { Injectable } from '@angular/core';
import { environment } from '@app-environments/environment';
import { ApiRequest } from '../api.request';
import { API_ROUTES } from '@app-shared/constants/routes/api.routes';
import {
  BaseGetByIdRequest,
  BaseGetCollectionResponse,
  BaseIdListRequest,
  BaseResponse,
} from '@app-types/base/base';
import { BaseCollectionFilteredSearchByIdRequest } from '@app-types/common';
import {
  ContactExportRequest,
  ContactGetRequest,
  ContactImportResultRowContract,
  ContactInfo,
  DeleteContactRequest,
  ImportContactsUploadRequest,
} from '@app-types/api/contact';
import { FileRefContract } from '@app-types/api/file';
import { GetSearchCounter } from '@app-types/api/group';
import { ContactTagSaveRequest } from '@app-types/api/tag';
import { ContactsSearchOrder } from '@app-types/enums/contacts';

const API_URL = environment.apiUrl;
const { contact, importContacts } = API_ROUTES;
const {
  search,
  exportExcel,
  exportVsCard,
  getSearchCounter,
  update,
  create,
  saveTags,
} = contact;
const { getImportTemplate } = importContacts;

@Injectable({
  providedIn: 'root',
})
export class ContactClient {
  constructor(private apiRequest: ApiRequest) {}

  async create(request: ContactInfo): Promise<ContactInfo> {
    return this.apiRequest.post(request, `${API_URL}${create}`);
  }

  async update(request: ContactInfo): Promise<ContactInfo> {
    return this.apiRequest.post(request, `${API_URL}${update}`);
  }

  async delete(request: DeleteContactRequest): Promise<void> {
    return this.apiRequest.post<BaseIdListRequest, void>(
      request,
      `${API_URL}${contact.delete}`
    );
  }

  async getById(
    request: ContactGetRequest
  ): Promise<BaseResponse<ContactInfo>> {
    return this.apiRequest.get(`${API_URL}${contact.get}?${request.format()}`);
  }

  // async getForAccount(
  //   request: BaseGetByIdRequest
  // ): Promise<BaseGetCollectionResponse<ContactInfo>> {
  //   return this.apiRequest.get(
  //     `${API_URL}${getForAccount}?${request.format()}`
  //   );
  // }

  async searchForAccount(
    request: BaseCollectionFilteredSearchByIdRequest<ContactsSearchOrder>
  ): Promise<BaseGetCollectionResponse<ContactInfo>> {
    return this.apiRequest.post(request, `${API_URL}${search}`, null);
  }

  async getSearchCounter(
    request: Partial<
      BaseCollectionFilteredSearchByIdRequest<ContactsSearchOrder>
    >
  ): Promise<GetSearchCounter> {
    return this.apiRequest.post(request, `${API_URL}${getSearchCounter}`);
  }

  async exportExcel(
    request: ContactExportRequest
  ): Promise<BaseResponse<FileRefContract>> {
    return this.apiRequest.post(request, `${API_URL}${exportExcel}`);
  }

  async exportVcCards(
    request: ContactExportRequest
  ): Promise<BaseResponse<FileRefContract>> {
    return this.apiRequest.post(request, `${API_URL}${exportVsCard}`);
  }

  async saveTags(request: ContactTagSaveRequest): Promise<void> {
    await this.apiRequest.post(request, `${API_URL}${saveTags}`);
  }

  async exportTemplate(
    request: BaseGetByIdRequest
  ): Promise<BaseResponse<FileRefContract>> {
    return this.apiRequest.get(
      `${API_URL}${getImportTemplate}?${request.format()}`
    );
  }

  async importContacts(
    request: ImportContactsUploadRequest
  ): Promise<BaseGetCollectionResponse<ContactImportResultRowContract>> {
    const formData = new FormData();
    Object.entries(request).forEach(([key, value]) => {
      if (value instanceof File) {
        formData.append(key, value, value.name);
      } else {
        formData.append(key, JSON.stringify(value));
      }
    });
    return this.apiRequest.post(formData, `${API_URL}${importContacts.import}`);
  }
}
